import TransitionExpand from '@limonische/vue3-transition-expand'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(TransitionExpand, {
    // global options
  })
})